import Vue from 'vue'

export const page = {
  namespaced: true,
  state: {
    loading: false,
    authority: false,
  },
  mutations: {
    loading(state, payload) {
      if (payload) {
        state.loading = true
      } else {
        state.loading = false
      }
    },
    authoritySet(state, payload) {
      state.authority = payload
    },
  },
}
